(function () {
  if (window.__loginReturnToInit) return;
  window.__loginReturnToInit = true;

  var RETURN_PARAM = 'return_to';
  var CHECKOUT_PARAM = 'checkout_url';

  function isAccountAuthPath(pathname) {
    return (
      pathname === '/account/login' ||
      pathname === '/account/register' ||
      pathname.indexOf('/account/login/') === 0 ||
      pathname.indexOf('/account/register/') === 0
    );
  }

  function isSafeReturnPath(value) {
    if (!value || typeof value !== 'string') return false;
    if (value.charAt(0) !== '/') return false;
    if (value.charAt(1) === '/') return false;
    if (value.indexOf('\\') !== -1) return false;
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(value)) return false;
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      if (isAccountAuthPath(parsed.pathname)) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function desiredReturnPath() {
    var params = new URLSearchParams(window.location.search);
    var fromQuery = params.get(RETURN_PARAM) || params.get(CHECKOUT_PARAM);
    if (isSafeReturnPath(fromQuery)) return fromQuery;

    if (!isAccountAuthPath(window.location.pathname)) {
      var current = window.location.pathname + window.location.search;
      if (isSafeReturnPath(current)) return current;
    }

    try {
      if (!document.referrer) return '';
      var referrer = new URL(document.referrer);
      if (referrer.origin !== window.location.origin) return '';
      var referrerPath = referrer.pathname + referrer.search;
      if (isSafeReturnPath(referrerPath)) return referrerPath;
    } catch (e) {
      return '';
    }

    return '';
  }

  function ensureHiddenInput(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function enhanceAuthForms() {
    var returnPath = desiredReturnPath();
    if (!returnPath) return;

    var loginForm = document.getElementById('customer_login');
    if (loginForm) {
      ensureHiddenInput(loginForm, RETURN_PARAM, returnPath);
      ensureHiddenInput(loginForm, CHECKOUT_PARAM, returnPath);
    }

    var registerForm = document.getElementById('create_customer');
    if (registerForm) {
      ensureHiddenInput(registerForm, RETURN_PARAM, returnPath);
    }
  }

  function enhanceLink(anchor) {
    if (!anchor || !anchor.getAttribute) return;
    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    if (url.origin !== window.location.origin) return;
    if (url.pathname !== '/account/login' && url.pathname !== '/account/register') return;
    if (url.searchParams.has(RETURN_PARAM) || url.searchParams.has(CHECKOUT_PARAM)) return;

    var returnPath = desiredReturnPath();
    if (!returnPath) return;

    url.searchParams.set(RETURN_PARAM, returnPath);
    anchor.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function enhanceAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = [];

    if (root && root.matches && (root.matches('a[href*="/account/login"]') || root.matches('a[href*="/account/register"]'))) {
      nodes.push(root);
    }

    scope.querySelectorAll('a[href*="/account/login"], a[href*="/account/register"]').forEach(function (anchor) {
      nodes.push(anchor);
    });

    nodes.forEach(enhanceLink);
  }

  function init() {
    enhanceAuthForms();
    enhanceAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          enhanceAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
